export default (permId) =>
  new Promise((resolve, reject) => {
    window.axios
      .delete(`${process.env.VUE_APP_API_ADMIN_LOCATION}permissions/${permId}/roles`)
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
